import React, { useEffect } from 'react';
import { SpinnerIcon } from 'components/common/Utils';
import useSpeechstream from './useSpeechStream';
import styles from './TextToSpeechButton.module.scss';

interface TTSButtonProps {
  idToRead: string;
  isInSlide?: boolean;
  locale: Locale;
  voice: string;
}

const SpeakElementButton = ({ idToRead, isInSlide, locale, voice }: TTSButtonProps) => {
  const { playing, toggleSpeech, loaded, setVoice, setNoScroll } = useSpeechstream({ idToRead, locale });
  const label = playing ? 'Pause' : 'Play';
  const iconClass = playing ? 'fa-pause' : 'fa-volume-up';

  useEffect(() => {
    setVoice(voice);
    setNoScroll(true);
  }, [loaded, voice]);

  if (isInSlide) {
    return (
      <div className={styles.seButtonWrapper}>
        <button
          aria-label={label}
          className="btn btn--outline-purple btn--sm speak-question-button"
          type="button"
          onClick={toggleSpeech}
        >
          {loaded ? <i aria-hidden="true" className={`fa ${iconClass}`} /> : <SpinnerIcon />}
        </button>
      </div>
    );
  }

  return (
    <button
      aria-label={label}
      className="btn btn--outline-purple btn--sm speak-question-button"
      type="button"
      onClick={toggleSpeech}
    >
      {loaded ? <i aria-hidden="true" className={`fa ${iconClass}`} /> : <SpinnerIcon />}
    </button>
  );
};

export default SpeakElementButton;
